import {IColumns} from '@baidu/icloud-ui-pro-table';

export const columns: IColumns = [
    {
        title: '参数名称',
        dataIndex: 'paramName',
        width: 200,
    },
    {
        title: '参数含义',
        dataIndex: 'paramDesc',
    },
    {
        title: '参数默认值',
        dataIndex: 'defaultValue',
    },
    {
        title: '参数可选值',
        dataIndex: 'selectValue',
    },
];
